export enum AccessEnum {
  Allow = 'allow',
  Deny = 'deny',
}

/** Access-rule actions supported by the API. */
export enum ActionEnum {
  Read = 'read',
  Write = 'write',
  ChrApprove = 'chr_approve',
}